import { SpiritMetadata as TSpiritMetadata } from '@phalaworld/types/phalaworld'

export const SpiritMetadata: Readonly<TSpiritMetadata> = {
  backgroundUri: "https://nft-assets.phala.world/artifacts/spirits/qQWeMqqazjBlJI9C_19afpKKnO2KXAo6TanQwnjXnRQ.png",
  description: "Spirit is a non-transferable Soulbound concept NFT generated with survivors unique on-chain identities. Each identity can claim one Spirit for free. All the contributions in Phala ecosystem will be counted into 4 attributes in Spirit. You can upgrade your Spirit when you make more contributions.",
  externalUri: "https://phala.world",
  mediaUri: "https://nft-assets.phala.world/artifacts/spirits/lmvwxsAs8KY2E74GLh-6QITOQalKqSQMFaToWY3l5-A.png",
  name: "Spirit",
}

export const OriginShellMetadata: Readonly<Record<string, Record<string, string>>> = {
  AISpectre: {
    name: 'AI Spectre',
    description:
      "AI can master the digital world, and they have the ability to control the 'elements'.",
    externalUri: 'https://phala.world',
    mediaUri: 'https://nft-assets.phala.world/artifacts/origins/Mcv-GJOd4iF42IKkTUzofzg3x6cBuiD9lsd429F56Ws.png',
    'mediaUri@2x':
      'https://nft-assets.phala.world/artifacts/origins/1eozW2C5mc09tilhJRWVYY7hExe_EmFYJ1aTYhBOd-w.png',
    'mediaUri@3x':
      'https://nft-assets.phala.world/artifacts/origins/g7BPUqwXJmCCpdCiF9K5zwcNLL9LPM2H60nD6GbbEoM.png',
    backgroundUri:
      'https://nft-assets.phala.world/artifacts/origins/00VkY8r9bo656ccHtMPSgQKGckWNfcJ8yTUEs-S3Res.png',
    'backgroundUri@2x':
      'https://nft-assets.phala.world/artifacts/origins/YfmvbEt_Mh2ipm-XQ2M4Dh691BzGNRUG-EEAA9Tnn8k.png',
    'backgroundUri@3x':
      'https://nft-assets.phala.world/artifacts/origins/E86G4QzYSJxZfstvsSkXwLMVVo96U_dJ66bCR-8aur4.png',
    videoUri: 'https://nft-assets.phala.world/artifacts/origins/RQDwEHicWhWB0cf6NR90EAVN_6549XZTlP-naV_kfkw.mp4',
    webmUri: 'https://nft-assets.phala.world/artifacts/origins/b-MA57BYhwcNazYL4cuYTeBOGhYRrnkxjlhTDAumG0g.webm',
  },
  Cyborg: {
    name: 'Cyborg',
    description: 'Cyborg is human who has been mechanically transformed.',
    externalUri: 'https://phala.world',
    mediaUri: 'https://nft-assets.phala.world/artifacts/origins/RobeW_Z-Pgh2GuKNTrH_Av10U8d70SJNuI9UduAHx0o.png',
    'mediaUri@2x':
      'https://nft-assets.phala.world/artifacts/origins/MMS59iXEkYfINNh4VE_94D0rUAE9NDot2Fpje586uiE.png',
    'mediaUri@3x':
      'https://nft-assets.phala.world/artifacts/origins/m4ilH_hAXq-yH_Ub0vp37Tcv18gAMREMndyKenwLfSI.png',
    backgroundUri:
      'https://nft-assets.phala.world/artifacts/origins/hkIko_7W_mv5h6kZLmPowg06LCKcxvnVQOWYR3iyVog.png',
    'backgroundUri@2x':
      'https://nft-assets.phala.world/artifacts/origins/EQuvz_6vBz6JqRbIozVR37Lr8R8U-JkzWN7KbDK5ow0.png',
    'backgroundUri@3x':
      'https://nft-assets.phala.world/artifacts/origins/j3Z9z8dYqjBTQJHJU-VBbJd4A0ViGkLZuxMJsRfClJU.png',
    videoUri: 'https://nft-assets.phala.world/artifacts/origins/IWcSOYRcNRM4gCIiqoTGGrvNk6XkmE_tesT_60IPy-Q.mp4',
    webmUri: 'https://nft-assets.phala.world/artifacts/origins/kzyGXBmmJMKeEHcYrpes2HOa2pV-X5aTeyxzaYH3jGA.webm',
  },
  Pandroid: {
    name: 'Pandroid',
    description:
      "Pandroid's main appeal is to help humans and AI reconcile and restore the world to a higher-tech order.",
    externalUri: 'https://phala.world',
    mediaUri: 'https://nft-assets.phala.world/artifacts/origins/vj4t0pkg9kfraJEm4dEbDxpxw3LJcZu7xt190jWOuNM.png',
    'mediaUri@2x':
      'https://nft-assets.phala.world/artifacts/origins/1IEqI-Vtouay0-QSuTzaxrMKnTQbA0P-bfJqZFWvpZk.png',
    'mediaUri@3x':
      'https://nft-assets.phala.world/artifacts/origins/dDrgG6AZwUAsTX464bufA7FfE3BBVMP9TyoMxNXNSrE.png',
    backgroundUri:
      'https://nft-assets.phala.world/artifacts/origins/TFb4qzQYxcNCR1KBFVfcNLMczipvVFWkbaeU0nBgsQ4.png',
    'backgroundUri@2x':
      'https://nft-assets.phala.world/artifacts/origins/95GpqXO3DktkbPLhxCfdNlF_NpNqbZses79eqj6oakE.png',
    'backgroundUri@3x':
      'https://nft-assets.phala.world/artifacts/origins/Pe_xVtDSnViynDsuxYpSANiFbsTbITnLBanQHgBs8cI.png',
    videoUri: 'https://nft-assets.phala.world/artifacts/origins/mGdfncq5_2DgEYT-HJigzjGGv6LcvlKkoshF5XQmwos.mp4',
    webmUri: 'https://nft-assets.phala.world/artifacts/origins/9YML_yI8UO9EolJgk6919jyd9H8mzUOizC_-Zf4QiWk.webm',
  },
  XGene: {
    name: 'X-Gene',
    description:
      "X-Gene's most important strategic goal is to find a way to survive and to make its species as important as humans. Equality is their main focus.",
    externalUri: 'https://phala.world',
    mediaUri: 'https://nft-assets.phala.world/artifacts/origins/QS45lFGravDOrq1ApzJBwQSGv2CIq39IeMHy3c-1R9o.png',
    'mediaUri@2x':
      'https://nft-assets.phala.world/artifacts/origins/6aXhzDafsdhj7IPY0o76PgtbuJbKzVuIjNyDZTDhMms.png',
    'mediaUri@3x':
      'https://nft-assets.phala.world/artifacts/origins/dfV-cQmpQwg6rCQnFrT7mVdvzW1Lw2eVVjEkX4uwdL8.png',
    backgroundUri:
      'https://nft-assets.phala.world/artifacts/origins/SbJXfb7V5C-WaaJkAWmA1FUa6c400uV8Y6DxRs4ZozA.png',
    'backgroundUri@2x':
      'https://nft-assets.phala.world/artifacts/origins/Dj7b5hlnpgviBKUgFPnh7yVy1Ap99REb8UH38JjITJo.png',
    'backgroundUri@3x':
      'https://nft-assets.phala.world/artifacts/origins/bdHkxV5s5mydPoEfBP1fT3Jb2f3VtuTI5ghdoQS6VMA.png',
    videoUri: 'https://nft-assets.phala.world/artifacts/origins/sOnkGV7ndaJSiB16STsKoFPhtq0Sq3ALXQFJvhBU4-Q.mp4',
    webmUri: 'https://nft-assets.phala.world/artifacts/origins/j4ZN-uTWiIE_5KUMjfcPK_AUvxDjKtv_9hnLvMDJYhg.webm',
  },
}